import React, { useState } from 'react';
import { Button } from '../ui/button';
import { OfficeSelect } from '../offices/OfficeSelect';

export const MovePatientsTool = ({ offices, onMove, confirm }) => {
  const [from, setFrom] = useState(offices[0]?.id);
  const [to, setTo] = useState(offices[1]?.id);
  return (
    <div className="bg-white border rounded-xl p-4 flex flex-wrap items-center gap-2 text-sm" data-testid="admin-move-patients">
      <span className="font-semibold mr-2">Move all patients from</span>
      <OfficeSelect offices={offices} value={from} onChange={setFrom} testId="admin-move-from" />
      <span>to</span>
      <OfficeSelect offices={offices} value={to} onChange={setTo} testId="admin-move-to" />
      <Button size="sm" variant="outline" disabled={!from || !to || from === to} data-testid="admin-move-btn"
        onClick={async () => (await confirm({ title: 'Move every patient?', text: 'All patients in the first office will belong to the second office.', ok: 'Move patients' })) && onMove(from, to)}>Move</Button>
    </div>
  );
};
